import { AxiosRequestConfig } from 'axios'

import { http } from './http'
import { Pagination, PaginationParams } from './map'
import {
  TicketCategory,
  TicketCategoryDetails,
  TicketCategoryPayload,
  TicketList,
  TicketPayload,
  Ticket,
  Vouchers,
} from '../../common/models'
import { InviteTicketsList } from '../../common/models/ticket'

export const getCategory = async (id: string) =>
  http.get<TicketCategoryDetails>(`/operations/ticket-category/${id}`)

export const updateTicketCategory = async (
  id: string,
  changes: TicketCategoryPayload,
) =>
  http.put<TicketCategory>(`/operations/ticket-category/${id}`, { ...changes })

export const deleteTicketCategory = async (id: string) =>
  http.delete<TicketCategory>(`/operations/ticket-category/${id}`)

export const unpublishTicketCategory = (ids: string[]) =>
  http.put<TicketCategory[]>('/operations/ticket-category/unpublish', {
    ids,
  })

export const publishTicketCategory = (ids: string[]) =>
  http.put<TicketCategory[]>('/operations/ticket-category/publish', {
    ids,
  })

export const getAllCategories = async (
  params?: PaginationParams,
  festivalName?: string,
) => {
  const config: AxiosRequestConfig = {
    params,
    headers: {},
  }

  if (festivalName && config.headers) {
    config.headers['x-festival-name'] = festivalName
  }

  return http.get<Pagination<TicketCategory>>(
    `/operations/ticket-category`,
    config,
  )
}

export const createTicketCategory = async (category: TicketCategoryPayload) =>
  http.post<TicketCategory>(`/operations/ticket-category`, {
    ...category,
  })

export const getTicketsByCategoryId = async (
  categoryId: string,
  params?: PaginationParams,
  justPublished?: boolean,
) =>
  http.get<Pagination<TicketList>>(
    `/operations/ticket-category/${categoryId}/tickets`,
    {
      params: {
        ...params,
        justPublished,
      },
    },
  )

export const getInviteTicketsByCategoryId = async (
  categoryId: string,
  params?: PaginationParams,
) =>
  http.get<InviteTicketsList[]>(
    `/operations/invites/category/${categoryId}/tickets`,
    { params },
  )

export const getTicketById = async (id: string) =>
  http.get<Ticket>(`/operations/ticket/${id}`)

export const updateTicketById = async (id: string, changes: TicketPayload) =>
  http.put<Ticket>(`/operations/ticket/${id}`, changes)

export const deleteTicketById = async (id: string) =>
  http.delete(`/operations/ticket/${id}`)

export const createTicket = async (ticket: TicketPayload) =>
  http.post<TicketPayload>(`/operations/ticket`, { ...ticket })

export const unpublishTicket = (ids: string[]) =>
  http.put<TicketCategory[]>('/operations/ticket/unpublish', {
    ids,
  })

export const publishTicket = (ids: string[]) =>
  http.put<TicketCategory[]>('/operations/ticket/publish', {
    ids,
  })

export const ticketVouchers = async (id: string) =>
  http.get<Vouchers[]>(`/operations/ticket/${id}/vouchers`)
